<template>

  <div class="col-md-6 col-lg-3" v-for="(item,index) in bv_list " :key="index">
    <div class="card bg-light h-100">
      <div class="card-body text-center " @click="go_tobv(item)">
        <img class="mb-3 rounder-circle" :src=item.pic
             alt="" style="width:160px;height: 90px">
        <h5 class="card-title">{{ item.title }}</h5>
        <p class="card-text">
          {{ item.name }}<br>
          播放:{{ item.view }}
          点赞:{{ item.like }}
          投币:{{ item.coin }}
          收藏:{{ item.favorite }}
        </p>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: 'BiliData',
  data() {
    return {
      bv_list: [
        {"name": "BV1Zs421376j"},
        {"name": "BV1c14y147Xt"},
        {"name": "BV1bf4y1N7yV"},
        {"name": "BV1xs411g7U9"}
      ],
    }
  },

  methods: {
    get_bv_data: function (tdict) {
      // alert(tdict);
      axios.get("bz/x/web-interface/view", {
        params: {
          bvid: tdict.name,
        }
      }).then(
          res => {
            console.log(res.data);
            tdict["view"] = res.data['data']['stat']["view"]
            tdict["coin"] = res.data['data']['stat']["coin"]
            tdict["favorite"] = res.data['data']['stat']["favorite"]
            tdict["like"] = res.data['data']['stat']["like"]
            tdict["pic"] = res.data['data']['pic']
            tdict["title"] = res.data['data']['title']
          }
      )

    },
    go_tobv: function (item) {
      window.open("https://www.bilibili.com/video/" + item.name, "_blank")
    },
  },

  mounted() {
    this.bv_list.forEach((item) => {
      this.$options.methods.get_bv_data(item);
    })

    console.log('渲染完成');
  },
}
</script>